import { FetchBaseQueryError } from "@reduxjs/toolkit/query/react"

export default function isFetchBaseQueryError(
  error: any,
): error is FetchBaseQueryError {
  return "status" in error
}
